import React, { useEffect } from 'react'
import { getStyles } from '../../utils/utils/commonUtils'
import photoGalleryDialogStyles from './styles/photoGalleryDialogStyles'
import { closeModalFn } from '../../utils/controllers/ModalController'
import cross from '../../assets/images/common/cross_dark.svg'
import { Box, IconButton, Typography } from '@mui/material'
const CustomTopPanel = ({ collectionName, collectionLength }) => {
  const classes = getStyles(photoGalleryDialogStyles)

  const closeModal = () => {
    closeModalFn['photo-gallery']()
  }

  useEffect(() => {
    function closeOnEscape(e) {
      if (e.key === 'Escape') {
        closeModal()
      }
    }

    window.addEventListener('keydown', closeOnEscape)

    return () => window.removeEventListener('keydown', closeOnEscape)
  }, [])

  return (
    <Box sx={classes.topPanel}>
      <Box sx={{ display: 'flex' }}>
        {collectionName && collectionLength && (
          <Typography sx={classes.topPanelText}>
            {collectionName} ({collectionLength})
          </Typography>
        )}
      </Box>

      <IconButton sx={classes.closeBtn} onClick={closeModal}>
        <img alt='close' src={cross} />
      </IconButton>
    </Box>
  )
}

export default CustomTopPanel
